module.exports = __webpack_public_path__ + "img/rewards-illustration.d73c1552.png";